import { useState } from "react"
import ContactSalesModal from "components/ContactSalesModal"
import { usePageAssets } from "hooks/usePageAssets"
import { openModal } from "utils/openModal"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Divider from "components/ui/Divider"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function GetStartedSection() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const { getAsset } = usePageAssets()
  const illustration = getAsset("api-get-started-svg")
  return (
    <Container section>
      <SplitContainer
        className="py-20"
        image={illustration}
        imageClassName="lg:w-1/3 lg:ml-16 xl:ml-20 2xl:ml-24 max-w-xl mx-auto"
        reversed
      >
        <Heading
          label="Get Started"
          title="Access the powerful Preset API"
          subtitle={
            <>
              Get in touch with our team to learn how our API can scale Preset
              Cloud deployment in your organization.
            </>
          }
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href="/contact-sales/"
          onClick={openModal(setIsContactModalOpen)}
          trackClick="Request Access (footer)_API"
          shadow
        >
          Request Access
        </Button>
      </SplitContainer>
      <Divider />
      <ContactSalesModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        sourcePage="API - Get Started"
      />
    </Container>
  )
}

export default GetStartedSection
